/**
 * API Configuration
 * 
 * Centralized configuration for all backend API endpoints.
 * Easily modify these URLs to point to different environments.
 */

// Base URLs for different environments
const API_BASE_URLS = {
  development: 'http://localhost:3003/api/v1',
  staging: 'https://staging-api.titan.com/api/v1',
  production: 'https://api.titan.com/api/v1',
};

// Get current environment (default to development)
const ENV = import.meta.env.MODE || 'development';

// Export the base URL for current environment
// Prioritize VITE_API_URL if set, otherwise use the environment-specific URL
export const API_BASE_URL = import.meta.env.VITE_API_URL || API_BASE_URLS[ENV];

/**
 * API Endpoints Configuration
 * All backend endpoints are defined here for easy maintenance
 */
export const API_ENDPOINTS = {
  // Dashboard endpoints
  dashboard: {
    shipments: '/dashboard/shipments',
    analytics: '/dashboard/analytics',
    performance: '/dashboard/performance',
  },

  // Transformation endpoints
  transformations: {
    list: '/transformations',
    create: '/transformations',
    update: (id) => `/transformations/${id}`,
    delete: (id) => `/transformations/${id}`,
    test: '/transformations/test',
  },

  // Vendor endpoints
  vendors: {
    list: '/vendors',
    fields: (vendorId) => `/vendors/${vendorId}/fields`,
  },

  // Connection test endpoint
  connection: {
    test: '/connection/test',
  },

  // Field mapping endpoints
  mappings: {
    autoMap: '/mappings/auto-map',
    validate: '/mappings/validate',
  },
};

/**
 * API Configuration per vendor
 * Used for direct vendor API connections in transformations
 */
export const VENDOR_API_CONFIG = {
  tracelink: {
    baseUrl: 'https://api.tracelink.com/v1',
    timeout: 30000,
    retries: 3,
  },
  sapattp: {
    baseUrl: 'https://api.sap.com/attp/v1',
    timeout: 30000,
    retries: 3,
  },
  rfxcel: {
    baseUrl: 'https://api.rfxcel.com/v1',
    timeout: 30000,
    retries: 3,
  },
};

/**
 * Request timeout configuration (in milliseconds)
 */
export const REQUEST_TIMEOUT = 30000;

/**
 * Number of retry attempts for failed requests
 */
export const MAX_RETRIES = 3;

/**
 * Helper function to build full API URL
 */
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  VENDOR_API_CONFIG,
  REQUEST_TIMEOUT,
  MAX_RETRIES,
  buildApiUrl,
};

